import { B2BUserRole } from '../../../../core/enums/b2bUserRoles';
import { StatusRequest } from '../../../../core/models/request-status.model';
import { UserRegisterRequest } from '../../user/core/user-aux.model';

export enum REQUEST_TYPE {
  REGISTER = 'Registration Request',
  ACCOUNT = 'Account Request',
  ROLE = 'Role Request',
  UNDEFINED = 'undefined',
}

export enum REPLY_REQUEST {
  APPROVE = 'approve',
  REPROVE = 'reprove',
}

export enum REQUEST_STATUS {
  REPROVED = 'Reproved',
  PENDING = 'Pending',
  APPROVED = 'Approved',
  UNDEFINED = 'undefined',
}

export interface Requisition {
  code?: string;
  date?: Date;
  status?: REQUEST_STATUS;
  type?: REQUEST_TYPE;
  user?: string;
}

export interface RequisitionsRequest extends StatusRequest {
  requests?: Requisition[];
}

export interface BaseRequisition {
  code?: string;
  user?: string;
  date?: Date;
  status?: REQUEST_STATUS;
  type?: REQUEST_TYPE;
  approvalDate?: Date;
  approvalUser?: string;
}

export interface RoleRequisition extends BaseRequisition {
  roleRequest?: {
    linkedAccounts?: string[];
    previousUserGroup?: string;
    userGroup?: string;
  };
}

export interface AccountRequisition extends BaseRequisition {
  accountRequest?: {
    linkedAccounts?: string[];
    account?: string;
    reason?: string;
  };
}

export interface RegisterRequisition extends BaseRequisition {
  registrationRequest?: UserRegisterRequest;
}

export interface RequistionDetailsRequest extends StatusRequest {
  type?: REQUEST_TYPE;
  roleRequest?: RoleRequisition;
  accountRequest?: AccountRequisition;
  registerRequest?: RegisterRequisition;
}

export interface RegisterData {
  accountNumbers?: string[];
  role?: B2BUserRole;
}

export interface ReplyConfig {
  code?: string;
  type?: REQUEST_TYPE;
  status?: REPLY_REQUEST;
  registerData?: RegisterData;
}
